module.exports = __webpack_public_path__ + "static/media/shapeButton.8cdfda6d.png";